/**
 * sessionSync — spec iter310 (2026-09-04).
 *
 * Le jeton vit en sessionStorage (meurt à la fermeture complète du
 * navigateur) mais est PARTAGÉ entre onglets via BroadcastChannel :
 *   • un onglet neuf sans jeton demande « req » ; tout onglet connecté
 *     répond « tok » → l'onglet neuf copie le jeton dans SON sessionStorage ;
 *   • login / logout sont diffusés pour garder tous les onglets alignés.
 */
const CH = "ledesk_auth";
const KEY = "ledesk_token";
let channel = null;

function getChannel() {
  if (channel || typeof BroadcastChannel === "undefined") return channel;
  channel = new BroadcastChannel(CH);
  channel.onmessage = (ev) => {
    const m = ev.data || {};
    if (m.type === "req") {
      const t = sessionStorage.getItem(KEY);
      if (t) channel.postMessage({ type: "tok", token: t });
    } else if (m.type === "logout") {
      sessionStorage.removeItem(KEY);
      window.dispatchEvent(new Event("ledesk-auth-changed"));
    } else if (m.type === "login" && m.token) {
      sessionStorage.setItem(KEY, m.token);
      window.dispatchEvent(new Event("ledesk-auth-changed"));
    }
  };
  return channel;
}

/** Récupère un jeton auprès des autres onglets (≤ 350 ms). */
export function requestTokenFromSiblings(timeoutMs = 350) {
  const ch = getChannel();
  if (!ch) return Promise.resolve(null);
  return new Promise((resolve) => {
    let done = false;
    const finish = (t) => { if (!done) { done = true; ch.removeEventListener("message", onMsg); resolve(t); } };
    const onMsg = (ev) => { if (ev.data?.type === "tok" && ev.data.token) { sessionStorage.setItem(KEY, ev.data.token); finish(ev.data.token); } };
    ch.addEventListener("message", onMsg);
    ch.postMessage({ type: "req" });
    setTimeout(() => finish(null), timeoutMs);
  });
}

export function broadcastLogin(token) { getChannel()?.postMessage({ type: "login", token }); }
export function broadcastLogout() { getChannel()?.postMessage({ type: "logout" }); }
export function startSessionSync() { getChannel(); }
